interface Props {
  title: string
}

const ReportTitle = ({ title }: Props) => {
  return <h2 className='text-2xl font-bold'>{title}</h2>
}

export default ReportTitle
